const inputForm = document.getElementById("cart");
inputForm.addEventListener("click", function (t) {
  const e = t.target;
  if (e.classList.contains("custom-cart__checkbox")) {
    const t = e.parentNode.querySelector(".custom-cart__area");
    e.checked ? (t.style.display = "block") : (t.style.display = "none");
  }
}),
  document.addEventListener("DOMContentLoaded", function () {
    if (
      !(function () {
        const t = window.navigator.userAgent,
          e = t.indexOf("MSIE "),
          n = t.indexOf("Trident/");
        return e > 0 || n > 0;
      })()
    )
      return;
    const t = document.createElement("input");
    t.setAttribute("name", "checkout"),
      t.setAttribute("type", "hidden"),
      document.querySelector("#cart").appendChild(t),
      document
        .querySelector("#checkout")
        .addEventListener("click", function (t) {
          document.querySelector("#cart").submit();
        });
  });
